import { useEffect } from 'react';

export const DocumentNameInitializer = () => {
  useEffect(() => {
    window.document.title = window.location.host.includes('notaris') ? 'Notaris.be' : 'Notaire.be';
  }, []);

  return null;
};
